/**
 * Pure math helpers for the PIMs scoring sensitivity calculator.
 *
 * Mirrors the linear-interpolation logic in sp_equip_cache_performance's
 * `pims_performance` CTE: a raw score is mapped to a 0..1 performance ratio,
 * where score ≤ floor → 1 (best) and score ≥ ceiling → 0 (worst).
 */

/** Map a raw score to a 0..1 performance ratio. */
export function calcPerf(score: number, floor: number, ceiling: number): number {
  if (score <= floor) return 1
  if (score >= ceiling) return 0
  return (ceiling - score) / (ceiling - floor)
}

/** Median of a numeric array. Returns 0 for empty input. Does not mutate. */
export function calcMedian(arr: number[]): number {
  if (arr.length === 0) return 0
  const sorted = [...arr].sort((a, b) => a - b)
  const mid = Math.floor(sorted.length / 2)
  return sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid]
}

/** Arithmetic mean of a numeric array. Returns 0 for empty input. */
export function calcMean(arr: number[]): number {
  if (arr.length === 0) return 0
  return arr.reduce((a, b) => a + b, 0) / arr.length
}
